import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const DialogStyle = (theme: Theme) => createStyles({
  backdrop: {
    background: styleColors.dialogBackdropGrey,
  },
  paper: {
    borderRadius: '0.375rem',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    boxSizing: 'border-box',

    '& > *': {
      boxSizing: 'border-box',
    }
  },
  dialogTitle: {
    padding: 0,
  },
  dialogContent: {
    padding: 0,
    wordBreak: 'break-word',
    '&:first-child': {
      padding: 0,
    }
  },
  dialogActions: {
    padding: 0,
  }
});



// WEBPACK FOOTER //
// ./src/components/common/dialog/dialog.style.ts